import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown } from 'lucide-react';
export function ValueStack() {
  const items = [{
    icon: '📘',
    name: 'Ebook Principal: El Protocolo Reinicio 40+',
    value: '$67 USD'
  }, {
    icon: '🛒',
    name: 'Bonus 1: Lista de Compras Perfecta',
    value: '$17 USD'
  }, {
    icon: '📊',
    name: 'Bonus 2: Checklist Diario de Bioseñales',
    value: '$12 USD'
  }, {
    icon: '🌮',
    name: 'Bonus 3: Guía de Sustitutos Latinos',
    value: '$17 USD'
  }, {
    icon: '⏱️',
    name: 'Bonus 4: Plan de Comidas Rápidas',
    value: '$22 USD'
  }, {
    icon: '🥤',
    name: 'Bonus 5: Recetario de Licuados Metabólicos',
    value: '$17 USD'
  }];
  return <section className="w-full bg-white py-16 px-4" data-id="element-338">
      <div className="max-w-[760px] mx-auto" data-id="element-339">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-[32px] font-bold text-center text-dark mb-8" data-id="element-340">
          Todo lo que Recibes Hoy:
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden mb-10" data-id="element-341">
          <div className="flex flex-col" data-id="element-342">
            {items.map((item, index) => <div key={index} className="flex justify-between items-center p-4 border-b border-gray-100 hover:bg-gray-50 transition-colors" data-id="element-343">
                <div className="flex items-center gap-3" data-id="element-344">
                  <span className="text-xl" data-id="element-345">{item.icon}</span>
                  <span className="font-bold text-[15px] md:text-[16px] text-dark" data-id="element-346">
                    {item.name}
                  </span>
                </div>
                <span className="font-bold text-[15px] md:text-[16px] text-teal text-right whitespace-nowrap ml-4" data-id="element-347">
                  {item.value}
                </span>
              </div>)}
            <div className="flex justify-between items-center p-5 bg-teal text-white" data-id="element-348">
              <span className="font-bold text-[18px]" data-id="element-349">
                VALOR TOTAL DEL SISTEMA
              </span>
              <span className="font-bold text-[18px]" data-id="element-350">{`$152 USD`}</span>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="flex flex-col items-center text-center mb-12" data-id="element-351">
          <div className="text-[20px] text-gray-400 line-through mb-2 font-medium" data-id="element-352">
            Valor total: $152 USD
          </div>
          <ArrowDown className="text-gray-300 w-6 h-6 mb-2" data-id="element-353" />
          <div className="flex flex-col items-center mb-4" data-id="element-354">
            <span className="text-[16px] text-dark font-medium mb-1" data-id="element-355">
              Tu precio hoy:
            </span>
            <div className="text-[48px] md:text-[56px] font-extrabold text-orange leading-none" data-id="element-356">
              $6.36 USD
            </div>
          </div>
          <div className="bg-lime text-white font-bold px-6 py-2 rounded-full text-[15px] shadow-md" data-id="element-357">
            Ahorras $145.64 USD (96% de descuento)
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-orange-light rounded-xl p-6 md:p-8 border border-orange/20" data-id="element-358">
          <h4 className="text-[18px] font-bold text-dark mb-3" data-id="element-359">
            ¿Por qué tan barato?
          </h4>
          <p className="text-[15px] text-[#555] leading-[1.8]" data-id="element-360">
            Estamos buscando 500 mujeres hispanas para validar el protocolo. A
            cambio de tu acceso anticipado, queremos tus resultados. Un pago
            único de $6.36 USD. Sin suscripciones. Sin cargos ocultos. Para
            siempre.
          </p>
        </motion.div>
      </div>
    </section>;
}